// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3k-FW","topBottomGutter":"Layout_topBottomGutter__SXDbS"};